var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.fromAirport || _vm.toAirport
        ? _c("suggestion-planes", {
            attrs: { fromAirport: _vm.fromAirport, toAirport: _vm.toAirport }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.fromAirport || _vm.toAirport
        ? _c("p", { class: { trip: !_vm.plane } }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("registration.flight-suggestions-title")) +
                "\n        " +
                _vm._s(
                  _vm.fromAirport
                    ? _vm.fromAirport.nomAeroport +
                        " (" +
                        (_vm.fromAirport.IATA
                          ? _vm.fromAirport.IATA
                          : _vm.fromAirport.OACI) +
                        ")"
                    : ""
                ) +
                "\n        " +
                _vm._s(_vm.toAirport ? " -> " : "") +
                "\n        " +
                _vm._s(
                  _vm.toAirport
                    ? _vm.toAirport.nomAeroport +
                        " (" +
                        (_vm.toAirport.IATA
                          ? _vm.toAirport.IATA
                          : _vm.toAirport.OACI) +
                        ")"
                    : ""
                ) +
                "\n    "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-537adffa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-537adffa","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/legs.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-537adffa","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/legs.vue
// module chunks = 1 2 3